{
  "$schema": "https://opencode.ai/desktop-theme.json",
  "name": "OpenCode",
  "id": "oc-2",
  "light": {
    "palette": {
      "neutral": "#f7f7f7",
      "ink": "#171311",
      "primary": "#dcde8d",
      "success": "#12c905",
      "warning": "#ffdc17",
      "error": "#fc533a",
      "info": "#a753ae",
      "interactive": "#034cff",
      "diffAdd": "#9ff29a",
      "diffDelete": "#fc533a"
    },
    "overrides": {
      "text-strong": "#171717",
      "text-base": "#6F6F6F",
      "text-weak": "#8F8F8F",
      "text-weaker": "#C7C7C7",
      "text-diff-add-base": "var(--v2-state-fg-success)",
      "text-diff-delete-base": "var(--v2-state-fg-danger)",
      "border-weak-base": "#DBDBDB",
      "border-weaker-base": "#E8E8E8",
      "icon-base": "#8F8F8F",
      "icon-weak-base": "C7C7C7",
      "surface-raised-base": "#F3F3F3",
      "surface-raised-base-hover": "#EDEDED",
      "surface-base": "#F8F8F8",
      "surface-base-hover": "#0000000A",
      "surface-interactive-weak": "#F5FAFF",
      "icon-success-base": "#0ABE00",
      "surface-success-base": "#E6FFE5",
      "syntax-comment": "var(--v2-text-text-muted)",
      "syntax-keyword": "var(--v2-pink-800)",
      "syntax-string": "var(--v2-green-800)",
      "syntax-primitive": "var(--v2-pink-800)",
      "syntax-property": "var(--v2-orange-800)",
      "syntax-type": "var(--v2-purple-800)",
      "syntax-constant": "#007b80",
      "syntax-critical": "var(--v2-red-800)",
      "syntax-diff-add": "var(--v2-state-fg-success)",
      "syntax-diff-delete": "var(--v2-state-fg-danger)",
      "syntax-diff-unknown": "#a753ae",
      "surface-critical-base": "#FFF2F0"
    },
    "v2Overrides": {
      "v2-grey-50": "#ffffffff",
      "v2-grey-100": "#fafafaff",
      "v2-grey-200": "#f2f2f2ff",
      "v2-grey-300": "#eeeeeeff",
      "v2-grey-400": "#dbdbdbff",
      "v2-grey-500": "#aeaeaeff",
      "v2-grey-600": "#808080ff",
      "v2-grey-700": "#5c5c5cff",
      "v2-grey-800": "#3a3a3aff",
      "v2-grey-900": "#2e2e2eff",
      "v2-grey-1000": "#242424ff",
      "v2-grey-1100": "#161616ff",
      "v2-grey-1200": "#080808ff",
      "v2-red-100": "#fcecebff",
      "v2-red-200": "#f6d5d3ff",
      "v2-red-300": "#f2bbb7ff",
      "v2-red-400": "#f29b96ff",
      "v2-red-500": "#f17471ff",
      "v2-red-600": "#f1484fff",
      "v2-red-700": "#d92e3cff",
      "v2-red-800": "#b82d35ff",
      "v2-red-900": "#97252bff",
      "v2-red-1000": "#7a1f23ff",
      "v2-red-1100": "#5f1a1cff",
      "v2-red-1200": "#461516ff",
      "v2-orange-100": "#fdf2edff",
      "v2-orange-200": "#ffe7dcff",
      "v2-orange-300": "#ffd8c6ff",
      "v2-orange-400": "#ffc1a4ff",
      "v2-orange-500": "#ffa478ff",
      "v2-orange-600": "#ff8648ff",
      "v2-orange-700": "#ee7330ff",
      "v2-orange-800": "#d16427ff",
      "v2-orange-900": "#b35624ff",
      "v2-orange-1000": "#954c27ff",
      "v2-orange-1100": "#723d22ff",
      "v2-orange-1200": "#5a2c14ff",
      "v2-yellow-100": "#fefaecff",
      "v2-yellow-200": "#fcefd0ff",
      "v2-yellow-300": "#f7e5b5ff",
      "v2-yellow-400": "#f3da9bff",
      "v2-yellow-500": "#f2cf76ff",
      "v2-yellow-600": "#f6c251ff",
      "v2-yellow-700": "#e7af36ff",
      "v2-yellow-800": "#cb9f34ff",
      "v2-yellow-900": "#ac8833ff",
      "v2-yellow-1000": "#8e7231ff",
      "v2-yellow-1100": "#68552bff",
      "v2-yellow-1200": "#4b4025ff",
      "v2-green-100": "#e7f9eaff",
      "v2-green-200": "#d0f0d5ff",
      "v2-green-300": "#b8e9c1ff",
      "v2-green-400": "#96e3a6ff",
      "v2-green-500": "#6bd586ff",
      "v2-green-600": "#49c970ff",
      "v2-green-700": "#2eaf5aff",
      "v2-green-800": "#198b43ff",
      "v2-green-900": "#1d783cff",
      "v2-green-1000": "#196130ff",
      "v2-green-1100": "#164c26ff",
      "v2-green-1200": "#14361dff",
      "v2-cyan-100": "#e2f7fbff",
      "v2-cyan-200": "#c4edf4ff",
      "v2-cyan-300": "#a3e4efff",
      "v2-cyan-400": "#65d9ebff",
      "v2-cyan-500": "#00c5dfff",
      "v2-cyan-600": "#00abcfff",
      "v2-cyan-700": "#0096b8ff",
      "v2-cyan-800": "#007d9bff",
      "v2-cyan-900": "#006c85ff",
      "v2-cyan-1000": "#005a6eff",
      "v2-cyan-1100": "#004756ff",
      "v2-cyan-1200": "#00353fff",
      "v2-blue-100": "#f5f8ffff",
      "v2-blue-200": "#ecf1feff",
      "v2-blue-300": "#c3d4fdff",
      "v2-blue-400": "#a2bcffff",
      "v2-blue-500": "#7698fdff",
      "v2-blue-600": "#3b5cf6ff",
      "v2-blue-700": "#0b34f4ff",
      "v2-blue-800": "#3250dfff",
      "v2-blue-900": "#2c47c8ff",
      "v2-blue-1000": "#263fa9ff",
      "v2-blue-1100": "#22388fff",
      "v2-blue-1200": "#021945ff",
      "v2-purple-100": "#ebecfeff",
      "v2-purple-200": "#d5d5fcff",
      "v2-purple-300": "#b9b8f5ff",
      "v2-purple-400": "#9e99f7ff",
      "v2-purple-500": "#8271f8ff",
      "v2-purple-600": "#7152f4ff",
      "v2-purple-700": "#623be2ff",
      "v2-purple-800": "#5230c2ff",
      "v2-purple-900": "#442aa1ff",
      "v2-purple-1000": "#361f83ff",
      "v2-purple-1100": "#2b1b6aff",
      "v2-purple-1200": "#221358ff",
      "v2-pink-100": "#fdecf3ff",
      "v2-pink-200": "#f7d5e4ff",
      "v2-pink-300": "#fabcd8ff",
      "v2-pink-400": "#f799c6ff",
      "v2-pink-500": "#f26cb2ff",
      "v2-pink-600": "#f64aabff",
      "v2-pink-700": "#e4429eff",
      "v2-pink-800": "#c83d8bff",
      "v2-pink-900": "#aa3576ff",
      "v2-pink-1000": "#8c2d61ff",
      "v2-pink-1100": "#6f284fff",
      "v2-pink-1200": "#5c1d3fff",
      "v2-background-bg-base": "var(--v2-grey-50)",
      "v2-background-bg-deep": "var(--v2-grey-100)",
      "v2-background-bg-layer-01": "var(--v2-grey-100)",
      "v2-background-bg-layer-02": "var(--v2-grey-200)",
      "v2-background-bg-layer-03": "var(--v2-grey-300)",
      "v2-background-bg-layer-04": "var(--v2-grey-400)",
      "v2-background-bg-inverse": "var(--v2-grey-1100)",
      "v2-background-bg-contrast": "var(--v2-grey-1000)",
      "v2-background-bg-icon-button-contrast": "var(--v2-background-bg-contrast)",
      "v2-background-bg-button-neutral": "var(--v2-grey-50)",
      "v2-background-bg-accent": "var(--v2-blue-600)",
      "v2-background-bg-code-path": "var(--v2-cyan-100)",
      "v2-text-text-base": "var(--v2-grey-1100)",
      "v2-text-text-muted": "var(--v2-grey-700)",
      "v2-text-text-faint": "var(--v2-grey-600)",
      "v2-text-text-inverse": "var(--v2-grey-50)",
      "v2-text-text-contrast": "var(--v2-grey-50)",
      "v2-text-text-accent": "var(--v2-blue-600)",
      "v2-text-text-accent-hover": "var(--v2-blue-700)",
      "v2-text-text-code-accent": "var(--v2-blue-900)",
      "v2-text-text-code-path": "var(--v2-blue-900)",
      "v2-icon-icon-base": "var(--v2-grey-800)",
      "v2-icon-icon-muted": "var(--v2-grey-600)",
      "v2-icon-icon-faint": "var(--v2-grey-500)",
      "v2-icon-icon-inverse": "var(--v2-grey-50)",
      "v2-icon-icon-contrast": "var(--v2-grey-100)",
      "v2-icon-icon-accent": "var(--v2-blue-600)",
      "v2-icon-icon-accent-hover": "var(--v2-blue-700)",
      "v2-border-border-muted": "var(--v2-alpha-dark-8)",
      "v2-border-border-base": "var(--v2-alpha-dark-10)",
      "v2-border-border-strong": "var(--v2-alpha-dark-20)",
      "v2-border-border-inverse": "var(--v2-grey-1000)",
      "v2-border-border-focus": "var(--v2-blue-500)",
      "v2-overlay-simple-overlay-hover": "var(--v2-alpha-dark-4)",
      "v2-overlay-simple-overlay-pressed": "var(--v2-alpha-dark-8)",
      "v2-overlay-simple-overlay-contrast-hover": "var(--v2-alpha-light-12)",
      "v2-overlay-simple-overlay-contrast-pressed": "var(--v2-alpha-light-24)",
      "v2-overlay-simple-overlay-scrim": "var(--v2-alpha-dark-40)",
      "v2-overlay-gradient-depth-overlay-depth-top": "var(--v2-alpha-light-100)",
      "v2-overlay-gradient-depth-overlay-depth-bot": "var(--v2-alpha-light-0)",
      "v2-overlay-simple-tab-active-scrim": "#fafafa00",
      "v2-overlay-simple-tab-hover-scrim": "#eeeeee00",
      "v2-overlay-simple-tab-scrim": "#fafafa00",
      "v2-state-bg-success": "var(--v2-green-100)",
      "v2-state-fg-success": "var(--v2-green-800)",
      "v2-state-border-success": "var(--v2-green-300)",
      "v2-state-bg-warning": "var(--v2-yellow-100)",
      "v2-state-fg-warning": "var(--v2-yellow-800)",
      "v2-state-border-warning": "var(--v2-yellow-300)",
      "v2-state-bg-danger": "var(--v2-red-100)",
      "v2-state-fg-danger": "var(--v2-red-800)",
      "v2-state-border-danger": "var(--v2-red-300)",
      "v2-state-bg-info": "var(--v2-blue-200)",
      "v2-state-fg-info": "var(--v2-blue-800)",
      "v2-state-border-info": "var(--v2-blue-300)",
      "v2-agent-plan-solid": "var(--v2-pink-800)",
      "v2-agent-plan-border": "rgba(200, 61, 139, 0.2)",
      "v2-agent-plan-background": "rgba(253, 236, 243, 0.1)",
      "v2-agent-build-solid": "var(--v2-blue-800)",
      "v2-agent-build-border": "rgba(44, 71, 200, 0.1)",
      "v2-agent-build-background": "rgba(236, 241, 254, 0.1)",
      "v2-agent-explore-solid": "var(--v2-yellow-900)",
      "v2-agent-explore-border": "rgba(203, 159, 52, 0.2)",
      "v2-agent-explore-background": "rgba(254, 250, 236, 0.1)",
      "v2-agent-review-solid": "var(--v2-green-800)",
      "v2-agent-writer-solid": "var(--v2-purple-700)",
      "v2-avatar-bg-orange": "#ee7330ff",
      "v2-avatar-border-orange": "#d16427ff",
      "v2-avatar-bg-yellow": "#e7af36ff",
      "v2-avatar-border-yellow": "#cb9f34ff",
      "v2-avatar-bg-cyan": "#0096b8ff",
      "v2-avatar-border-cyan": "#007d9bff",
      "v2-avatar-bg-green": "#2eaf5aff",
      "v2-avatar-border-green": "#198b43ff",
      "v2-avatar-bg-red": "#d92e3cff",
      "v2-avatar-border-red": "#b82d35ff",
      "v2-avatar-bg-pink": "#e4429eff",
      "v2-avatar-border-pink": "#c83d8bff",
      "v2-avatar-bg-blue": "#3250dfff",
      "v2-avatar-border-blue": "#2c47c8ff",
      "v2-avatar-bg-purple": "#623be2ff",
      "v2-avatar-border-purple": "#5230c2ff",
      "v2-avatar-bg-gray": "#5c5c5cff",
      "v2-avatar-border-gray": "#3a3a3aff",
      "v2-elevation-raised": "0px 2px 4px 0px var(--v2-alpha-dark-4), 0px 1px 2px -1px var(--v2-alpha-dark-8), 0px 0px 0px 0.5px var(--v2-alpha-dark-12), 0px 0px 0px 0px var(--v2-alpha-dark-0)",
      "v2-elevation-floating": "0px 8px 16px 0px var(--v2-alpha-dark-4), 0px 4px 8px 0px var(--v2-alpha-dark-8), 0px 0px 0px 0.5px var(--v2-alpha-dark-12), 0px 0px 0px 0px var(--v2-alpha-dark-0)",
      "v2-elevation-overlay": "0px 16px 32px 0px var(--v2-alpha-dark-4), 0px 8px 16px 0px var(--v2-alpha-dark-8), 0px 0px 0px 0.5px var(--v2-alpha-dark-12), 0px 0px 0px 0px var(--v2-alpha-dark-0)",
      "v2-elevation-button-neutral": "0px 1px 1.5px 0px var(--v2-alpha-dark-10), 0px 0px 0px 0.5px var(--v2-alpha-dark-14), 0px 0px 0px 0px var(--v2-alpha-dark-0)",
      "v2-elevation-button-contrast": "0px 1px 1.5px 0px var(--v2-alpha-dark-20), 0px 0px 0px 0.5px var(--v2-grey-800), inset 0px 1px 2px 0px var(--v2-alpha-light-14), inset 0px -1px 2px 0px var(--v2-alpha-dark-6), 0px 0px 0px 0px var(--v2-alpha-dark-0)",
      "v2-elevation-elements": "0px 0.5px 0.5px 0px var(--v2-alpha-dark-40)",
      "v2-elevation-switch-off": "inset 0px 1px 1px 0px var(--v2-alpha-dark-8), inset 0px 0.5px 0.5px 0px var(--v2-alpha-dark-8), inset 0px 0px 0px 0.5px var(--v2-alpha-dark-10)",
      "v2-elevation-switch-on": "inset 0px 2px 2px 0px var(--v2-alpha-dark-10), inset 0px 1px 1px 0px var(--v2-alpha-dark-10), inset 0px 0px 0px 0.5px var(--v2-alpha-dark-20)",
      "v2-illustration-illustration-layer-01": "var(--v2-grey-300)",
      "v2-illustration-illustration-layer-02": "var(--v2-grey-400)",
      "v2-illustration-illustration-layer-03": "var(--v2-grey-500)",
      "v2-font-family-code": "var(--font-family-mono)"
    }
  },
  "dark": {
    "palette": {
      "neutral": "#1f1f1f",
      "ink": "#f1ece8",
      "primary": "#fab283",
      "success": "#12c905",
      "warning": "#fcd53a",
      "error": "#fc533a",
      "info": "#edb2f1",
      "interactive": "#034cff",
      "diffAdd": "#c8ffc4",
      "diffDelete": "#fc533a"
    },
    "overrides": {
      "text-strong": "#EDEDED",
      "text-base": "#A0A0A0",
      "text-weak": "#707070",
      "text-weaker": "#505050",
      "text-diff-add-base": "var(--v2-state-fg-success)",
      "text-diff-delete-base": "var(--v2-state-fg-danger)",
      "border-weak-base": "#282828",
      "border-weaker-base": "#232323",
      "icon-base": "#7E7E7E",
      "icon-weak-base": "#343434",
      "surface-raised-base": "#232323",
      "surface-raised-base-hover": "#282828",
      "surface-base": "#1C1C1C",
      "surface-base-hover": "#FFFFFF0D",
      "surface-interactive-weak": "#0D172B",
      "surface-success-base": "#022B00",
      "syntax-comment": "var(--v2-text-text-muted)",
      "syntax-keyword": "var(--v2-pink-400)",
      "syntax-string": "var(--v2-green-400)",
      "syntax-primitive": "var(--v2-pink-400)",
      "syntax-property": "var(--v2-orange-400)",
      "syntax-type": "var(--v2-purple-400)",
      "syntax-constant": "#93e9f6",
      "syntax-critical": "var(--v2-red-400)",
      "syntax-diff-add": "var(--v2-state-fg-success)",
      "syntax-diff-delete": "var(--v2-state-fg-danger)",
      "syntax-diff-unknown": "#edb2f1",
      "surface-critical-base": "#1F0603"
    },
    "v2Overrides": {
      "v2-grey-50": "#ffffffff",
      "v2-grey-100": "#fafafaff",
      "v2-grey-200": "#f2f2f2ff",
      "v2-grey-300": "#eeeeeeff",
      "v2-grey-400": "#dbdbdbff",
      "v2-grey-500": "#aeaeaeff",
      "v2-grey-600": "#808080ff",
      "v2-grey-700": "#5c5c5cff",
      "v2-grey-800": "#3a3a3aff",
      "v2-grey-900": "#2e2e2eff",
      "v2-grey-1000": "#242424ff",
      "v2-grey-1100": "#161616ff",
      "v2-grey-1200": "#080808ff",
      "v2-red-100": "#fcecebff",
      "v2-red-200": "#f6d5d3ff",
      "v2-red-300": "#f2bbb7ff",
      "v2-red-400": "#f29b96ff",
      "v2-red-500": "#f17471ff",
      "v2-red-600": "#f1484fff",
      "v2-red-700": "#d92e3cff",
      "v2-red-800": "#b82d35ff",
      "v2-red-900": "#97252bff",
      "v2-red-1000": "#7a1f23ff",
      "v2-red-1100": "#5f1a1cff",
      "v2-red-1200": "#461516ff",
      "v2-orange-100": "#fdf2edff",
      "v2-orange-200": "#ffe7dcff",
      "v2-orange-300": "#ffd8c6ff",
      "v2-orange-400": "#ffc1a4ff",
      "v2-orange-500": "#ffa478ff",
      "v2-orange-600": "#ff8648ff",
      "v2-orange-700": "#ee7330ff",
      "v2-orange-800": "#d16427ff",
      "v2-orange-900": "#b35624ff",
      "v2-orange-1000": "#954c27ff",
      "v2-orange-1100": "#723d22ff",
      "v2-orange-1200": "#5a2c14ff",
      "v2-yellow-100": "#fefaecff",
      "v2-yellow-200": "#fcefd0ff",
      "v2-yellow-300": "#f7e5b5ff",
      "v2-yellow-400": "#f3da9bff",
      "v2-yellow-500": "#f2cf76ff",
      "v2-yellow-600": "#f6c251ff",
      "v2-yellow-700": "#e7af36ff",
      "v2-yellow-800": "#cb9f34ff",
      "v2-yellow-900": "#ac8833ff",
      "v2-yellow-1000": "#8e7231ff",
      "v2-yellow-1100": "#68552bff",
      "v2-yellow-1200": "#4b4025ff",
      "v2-green-100": "#e7f9eaff",
      "v2-green-200": "#d0f0d5ff",
      "v2-green-300": "#b8e9c1ff",
      "v2-green-400": "#96e3a6ff",
      "v2-green-500": "#6bd586ff",
      "v2-green-600": "#49c970ff",
      "v2-green-700": "#2eaf5aff",
      "v2-green-800": "#198b43ff",
      "v2-green-900": "#1d783cff",
      "v2-green-1000": "#196130ff",
      "v2-green-1100": "#164c26ff",
      "v2-green-1200": "#14361dff",
      "v2-cyan-100": "#e2f7fbff",
      "v2-cyan-200": "#c4edf4ff",
      "v2-cyan-300": "#a3e4efff",
      "v2-cyan-400": "#65d9ebff",
      "v2-cyan-500": "#00c5dfff",
      "v2-cyan-600": "#00abcfff",
      "v2-cyan-700": "#0096b8ff",
      "v2-cyan-800": "#007d9bff",
      "v2-cyan-900": "#006c85ff",
      "v2-cyan-1000": "#005a6eff",
      "v2-cyan-1100": "#004756ff",
      "v2-cyan-1200": "#00353fff",
      "v2-blue-100": "#f5f8ffff",
      "v2-blue-200": "#ecf1feff",
      "v2-blue-300": "#c3d4fdff",
      "v2-blue-400": "#a2bcffff",
      "v2-blue-500": "#7698fdff",
      "v2-blue-600": "#3b5cf6ff",
      "v2-blue-700": "#0b34f4ff",
      "v2-blue-800": "#3250dfff",
      "v2-blue-900": "#2c47c8ff",
      "v2-blue-1000": "#263fa9ff",
      "v2-blue-1100": "#22388fff",
      "v2-blue-1200": "#021945ff",
      "v2-purple-100": "#ebecfeff",
      "v2-purple-200": "#d5d5fcff",
      "v2-purple-300": "#b9b8f5ff",
      "v2-purple-400": "#9e99f7ff",
      "v2-purple-500": "#8271f8ff",
      "v2-purple-600": "#7152f4ff",
      "v2-purple-700": "#623be2ff",
      "v2-purple-800": "#5230c2ff",
      "v2-purple-900": "#442aa1ff",
      "v2-purple-1000": "#361f83ff",
      "v2-purple-1100": "#2b1b6aff",
      "v2-purple-1200": "#221358ff",
      "v2-pink-100": "#fdecf3ff",
      "v2-pink-200": "#f7d5e4ff",
      "v2-pink-300": "#fabcd8ff",
      "v2-pink-400": "#f799c6ff",
      "v2-pink-500": "#f26cb2ff",
      "v2-pink-600": "#f64aabff",
      "v2-pink-700": "#e4429eff",
      "v2-pink-800": "#c83d8bff",
      "v2-pink-900": "#aa3576ff",
      "v2-pink-1000": "#8c2d61ff",
      "v2-pink-1100": "#6f284fff",
      "v2-pink-1200": "#5c1d3fff",
      "v2-background-bg-base": "var(--v2-grey-1100)",
      "v2-background-bg-deep": "var(--v2-grey-1200)",
      "v2-background-bg-layer-01": "var(--v2-grey-1000)",
      "v2-background-bg-layer-02": "var(--v2-grey-900)",
      "v2-background-bg-layer-03": "var(--v2-grey-800)",
      "v2-background-bg-layer-04": "var(--v2-grey-700)",
      "v2-background-bg-inverse": "var(--v2-grey-50)",
      "v2-background-bg-contrast": "var(--v2-grey-700)",
      "v2-background-bg-icon-button-contrast": "var(--v2-grey-400)",
      "v2-background-bg-button-neutral": "var(--v2-alpha-light-6)",
      "v2-background-bg-accent": "var(--v2-blue-600)",
      "v2-background-bg-code-path": "var(--v2-cyan-1200)",
      "v2-text-text-base": "var(--v2-grey-100)",
      "v2-text-text-muted": "var(--v2-grey-500)",
      "v2-text-text-faint": "var(--v2-grey-600)",
      "v2-text-text-inverse": "var(--v2-grey-1100)",
      "v2-text-text-contrast": "var(--v2-grey-50)",
      "v2-text-text-accent": "var(--v2-blue-400)",
      "v2-text-text-accent-hover": "var(--v2-blue-300)",
      "v2-text-text-code-accent": "var(--v2-blue-400)",
      "v2-text-text-code-path": "var(--v2-blue-300)",
      "v2-icon-icon-base": "var(--v2-grey-400)",
      "v2-icon-icon-muted": "var(--v2-grey-600)",
      "v2-icon-icon-faint": "var(--v2-grey-700)",
      "v2-icon-icon-inverse": "var(--v2-grey-1100)",
      "v2-icon-icon-contrast": "var(--v2-grey-100)",
      "v2-icon-icon-accent": "var(--v2-blue-400)",
      "v2-icon-icon-accent-hover": "var(--v2-blue-300)",
      "v2-border-border-muted": "var(--v2-alpha-light-8)",
      "v2-border-border-base": "var(--v2-alpha-light-10)",
      "v2-border-border-strong": "var(--v2-alpha-light-20)",
      "v2-border-border-inverse": "var(--v2-grey-100)",
      "v2-border-border-focus": "var(--v2-blue-500)",
      "v2-overlay-simple-overlay-hover": "var(--v2-alpha-light-6)",
      "v2-overlay-simple-overlay-pressed": "var(--v2-alpha-light-10)",
      "v2-overlay-simple-overlay-contrast-hover": "var(--v2-alpha-dark-24)",
      "v2-overlay-simple-overlay-contrast-pressed": "var(--v2-alpha-dark-40)",
      "v2-overlay-simple-overlay-scrim": "var(--v2-alpha-dark-60)",
      "v2-overlay-gradient-depth-overlay-depth-top": "var(--v2-alpha-light-100)",
      "v2-overlay-gradient-depth-overlay-depth-bot": "var(--v2-alpha-light-0)",
      "v2-overlay-simple-tab-active-scrim": "#24242400",
      "v2-overlay-simple-tab-hover-scrim": "#3a3a3a00",
      "v2-overlay-simple-tab-scrim": "#08080800",
      "v2-state-bg-success": "var(--v2-green-1200)",
      "v2-state-fg-success": "var(--v2-green-500)",
      "v2-state-border-success": "var(--v2-green-900)",
      "v2-state-bg-warning": "var(--v2-yellow-1200)",
      "v2-state-fg-warning": "var(--v2-yellow-500)",
      "v2-state-border-warning": "var(--v2-yellow-900)",
      "v2-state-bg-danger": "var(--v2-red-1200)",
      "v2-state-fg-danger": "var(--v2-red-500)",
      "v2-state-border-danger": "var(--v2-red-900)",
      "v2-state-bg-info": "var(--v2-blue-1200)",
      "v2-state-fg-info": "var(--v2-blue-500)",
      "v2-state-border-info": "var(--v2-blue-900)",
      "v2-agent-plan-solid": "var(--v2-pink-400)",
      "v2-agent-plan-border": "rgba(247, 153, 198, 0.2)",
      "v2-agent-plan-background": "rgba(170, 53, 118, 0.05)",
      "v2-agent-build-solid": "var(--v2-blue-300)",
      "v2-agent-build-border": "rgba(162, 188, 255, 0.2)",
      "v2-agent-build-background": "rgba(38, 63, 169, 0.05)",
      "v2-agent-explore-solid": "var(--v2-yellow-300)",
      "v2-agent-explore-border": "rgba(243, 218, 155, 0.2)",
      "v2-agent-explore-background": "rgba(172, 136, 51, 0.05)",
      "v2-agent-review-solid": "var(--v2-green-300)",
      "v2-agent-writer-solid": "var(--v2-purple-400)",
      "v2-avatar-bg-orange": "#723d22ff",
      "v2-avatar-border-orange": "#ff8648ff",
      "v2-avatar-bg-yellow": "#68552bff",
      "v2-avatar-border-yellow": "#e7af36ff",
      "v2-avatar-bg-cyan": "#005a6eff",
      "v2-avatar-border-cyan": "#0096b8ff",
      "v2-avatar-bg-green": "#196130ff",
      "v2-avatar-border-green": "#49c970ff",
      "v2-avatar-bg-red": "#7a1f23ff",
      "v2-avatar-border-red": "#d92e3cff",
      "v2-avatar-bg-pink": "#8c2d61ff",
      "v2-avatar-border-pink": "#e4429eff",
      "v2-avatar-bg-blue": "#263fa9ff",
      "v2-avatar-border-blue": "#7698fdff",
      "v2-avatar-bg-purple": "#361f83ff",
      "v2-avatar-border-purple": "#7152f4ff",
      "v2-avatar-bg-gray": "#5c5c5cff",
      "v2-avatar-border-gray": "#aeaeaeff",
      "v2-elevation-raised": "0px 2px 4px 0px var(--v2-alpha-dark-30), 0px 1px 2px 0px var(--v2-alpha-dark-30), 0px 0px 0px 0.5px var(--v2-alpha-light-16), 0px -0.5px 0px 0px var(--v2-alpha-light-6)",
      "v2-elevation-floating": "0px 8px 16px 0px var(--v2-alpha-dark-30), 0px 4px 8px 0px var(--v2-alpha-dark-30), 0px 0px 0px 0.5px var(--v2-alpha-light-16), 0px -0.5px 0px 0px var(--v2-alpha-light-6)",
      "v2-elevation-overlay": "0px 16px 32px 0px var(--v2-alpha-dark-30), 0px 8px 16px 0px var(--v2-alpha-dark-30), 0px 0px 0px 0.5px var(--v2-alpha-light-16), 0px -0.5px 0px 0px var(--v2-alpha-light-6)",
      "v2-elevation-button-neutral": "0px 1px 2px 0px var(--v2-alpha-dark-40), 0px 0px 0px 0.5px var(--v2-alpha-light-20), 0px -0.5px 0px 0px var(--v2-alpha-light-10)",
      "v2-elevation-button-contrast": "0px 1px 2px 0px var(--v2-alpha-dark-40), 0px 0px 0px 0.5px var(--v2-alpha-light-40), inset 0px 0px 0px 0px var(--v2-alpha-light-0), inset 0px 0px 0px 0px var(--v2-alpha-light-0), 0px -0.5px 0px 0px var(--v2-alpha-light-30)",
      "v2-elevation-elements": "0px 0.5px 0.5px 0px var(--v2-alpha-dark-40)",
      "v2-elevation-switch-off": "inset 0px -0.5px 0px 0px var(--v2-alpha-light-10), inset 0px 0px 0px 0px var(--v2-alpha-light-0), inset 0px 0px 0px 0.5px var(--v2-alpha-light-16)",
      "v2-elevation-switch-on": "inset 0px -0.5px 0px 0px var(--v2-alpha-light-10), inset 0px 0px 0px 0px var(--v2-alpha-light-0), inset 0px 0px 0px 0.5px var(--v2-alpha-light-16)",
      "v2-illustration-illustration-layer-01": "var(--v2-grey-900)",
      "v2-illustration-illustration-layer-02": "var(--v2-grey-800)",
      "v2-illustration-illustration-layer-03": "var(--v2-grey-700)"
    }
  }
}
